import React, { useState,useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Form,
  Button,
  Col,
  Row,
  Badge,
} from 'react-bootstrap';
import {  insert_new_opportunity } from '../../../../utils/crm_services';
import { loadCountriesData, buildCountrySelectOptions } from '../../../../utils/countries';
import Select from 'react-select';


function New_opportunity  ({user_id, channel_name, onSet, token, channel_id }) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    
  const [countryOptions, setcountryOptions] = useState([]);
   
   const [opportunityName, setOpportunityName] = useState('');
    const [editableOpportunityName, setEditableOpportunityName] = useState('');  
    const [country, setCountry] = useState('');
    const [type, setType] = useState(0);
    
    const [description, setDescription] = useState('');
    const [closingDate, setClosingDate] = useState('');
    const [protectedUntil, setProtectedUntil] = useState('');
  
  
    
    const handleNameChange = (event) => {
      const newValue = event.target.value;
      setEditableOpportunityName(newValue);
  
  };

  const formatOptionLabel = ({ label, flagUrl }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {flagUrl && <img src={flagUrl} alt={`Flag of ${label}`} style={{ width: '20px', marginRight: '10px' }} />}
      <span>{label}</span>
    </div>
  );

  
    //--------------------- LINKING ELEMENTS
    const createNewOpportunity =() =>{
        
          async function fetchcreateNew(name, channel_id) {

            const opportunityList = await insert_new_opportunity(token,name,channel_id, description, protectedUntil, closingDate, country, type, 0, 'new');
            if (opportunityList==="INVALID"){
              navigate("/");
            }else {
              navigate("/opportunitypage?id=" + opportunityList);
            }
          }

          fetchcreateNew(editableOpportunityName, channel_id);
    
    }
    

        const typeOptions = [
          { label: 'Public', value: 0 },
          { label: 'Private', value: 1 }
        ];

        const getOptionByValue = (value) => {
          return countryOptions.find(option => option.value === value);
        };
   
         useEffect(() => {
                    loadCountriesData()
                      .then((data) => {
                        setcountryOptions(buildCountrySelectOptions(data));
                      })
                      .catch((error) => console.error('Error fetching countries:', error));
                  }, []);

            
    const getTypeByValue = (value) => {
      return typeOptions.find(option => option.value === value);
    };
            
        
    // ---------- UI ----------
    return (
        <div className="col-lg-12">
           <Row className="gy-4 mb-2">
               {/* ----------------- Título ----------------- */}
               <Col xs={12} md={8}>
                   <div className="label-normal">
                   Opportunity Name:
                   </div>
                   <input
                           type="text"
                           className="display-5 fw-bold mb-0 text-start opportunity-name-input" // Add a class for potential styling
                           value={editableOpportunityName}
                           placeholder='New Opportunity Name'
                           onChange={handleNameChange}
                   />
               </Col>
       
         
       
                <Col xs={12} md={4}>
                   
       
                   <div  style={{ cursor: "pointer" }}  className="d-flex align-items-center mb-3">
                       <div>
                           {channel_name ? (
                               <Badge pill bg="primary" className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8">
                                   
                                   {channel_name && channel_name.length > 25
                                       ? channel_name.slice(0, 25) + '...'
                                       : channel_name}
                               </Badge>
                           ) : ''}
                       </div>
                   </div>
       
                 
                   {/* ------------ Botón del Switch en su propia línea --------------- */}
                   {/* No necesitas un div adicional si quieres que el botón ocupe todo el ancho de la columna
                       y el propio botón ya tiene la clase w-100 */}
                  
                   </Col>
           </Row>
               <div className="d-flex flex-wrap gap-2 justify-content-lg-end mt-auto mb-1 ">
                   {/* Fila 3: Description full width */}
                   <Col xs={12}>
                       <Form.Group controlId="description">
       
                           <Form.Control
                           as="textarea"
                           rows={4}
                           value={description}
                           placeholder="Description..."
                           onChange={(e) => {
                               setDescription(e.target.value)
                           }}
                           />
                       </Form.Group>
                   </Col>
               </div>
               <Row className="gy-2 mb-2 gx-1">
                       <Col xs={12} md={3}>
                               <Form.Group as={Row} controlId="protected-until">
                                   <Form.Label column sm={12}>Protection:</Form.Label>
                               
                                   <Col sm={12}>
                                       <Form.Control
                                           type="date"
                                           value={protectedUntil}
                                           onChange={(e) =>{ 
                                               setProtectedUntil(e.target.value);
                                           }}
                                       />
                                   </Col>
                                   
                               </Form.Group>
                       </Col>
                   
                       <Col xs={12} md={3}> {/* Nota: xs={20} es inusual, Bootstrap usa un sistema de 12 columnas. Quizás querías xs={12} o ajustar md */}
                               <Form.Group as={Row} controlId="closing-date">
                                   <Form.Label column sm={12}>Closing:</Form.Label>
                                   <Col sm={12}> {/* Ajustado sm={5} para que quepa mejor si Form.Label es sm={4} */}
                                       <Form.Control
                                           type="date"
                                           value={closingDate}
                                           onChange={(e) => {
                                               setClosingDate(e.target.value);
                                           }}
                                       />
                                   </Col>
                               </Form.Group>
                           </Col>
                   
                       {/* Fila 2: Country */}
                       <Col xs={12} md={3}>
                           <Form.Group as={Row} controlId="country">
                           <Form.Label column sm={12}>Country:</Form.Label>
                               <Select
                                  menuPosition="fixed"
                                   className="react-select-container"
                                   classNamePrefix="react-select"
                                   options={countryOptions}
                                   isLoading={countryOptions.length === 0}
                                   formatOptionLabel={formatOptionLabel}
                                   onChange={(selectedOption) =>{
                                        setCountry(selectedOption.value);
                                       }}
                                   value={getOptionByValue(country)}
                                   placeholder="Country..."
                                   isSearchable
                                   styles={{
                                       container: (provided) => ({
                                         ...provided,
                                         minWidth: 100, // o usa width: '100%' para expansión completa
                                         flex: 1,       // permite que crezca en d-flex
                                       }),
                                         menu: (provided) => ({
                                             ...provided,
                                             zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                                         }),
                                         // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                                         menuPortal: (base) => ({
                                             ...base,
                                             zIndex: 9999
                                         })
                                     }}
                               />
                              
                           </Form.Group>
                       </Col>
                       {/* Fila 2: Type */} {/* Movido Type aquí para que esté en la misma fila visual que Country */}
                       <Col xs={12} md={3}>
                           <Form.Group as={Row} controlId="type">
                           <Form.Label column sm={12}>Type:</Form.Label>
                              
                               <Select
                                   menuPosition="fixed"
                                   className="react-select-container"
                                   classNamePrefix="react-select"
                                   options={typeOptions}
                                   isLoading={typeOptions.length === 0}
                                   onChange={(selectedOption) => setType(selectedOption.value)}
                                   placeholder="Type..."
                                   value={getTypeByValue(type)}
                                   styles={{
                                       container: (provided) => ({
                                         ...provided,
                                         minWidth: 100, // o usa width: '100%' para expansión completa
                                         flex: 1,       // permite que crezca en d-flex
                                       }),
                                         menu: (provided) => ({
                                             ...provided,
                                             zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                                         }),
                                         // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                                         menuPortal: (base) => ({
                                             ...base,
                                             zIndex: 9999
                                         })
                                     }}
                               />
                               
                           </Form.Group>
                       </Col>
                       
                     
               </Row>
               {/* The div below will be pushed to the bottom */}
               <div className="d-flex flex-wrap gap-2 justify-content-lg-end mt-auto ">
                   {/* Conditionally render the Save Change button */}
                  
                   <Button
                       variant="danger"
                       size="sm"
                       onClick={()=>{createNewOpportunity()}}
                       // Call the new save handler
                   >
                      Create Opportunity
                   </Button>
                   
                   {/* You might also want a Cancel button here if the name is edited */}
                   
                   <Button
                       variant="outline-secondary"
                       size="sm"
                       onClick={() => {
                           setEditableOpportunityName(opportunityName); // Reset to original name
                       }}
                   >
                       Cancel
                   </Button>
                   
               </div>
           </div>
    );
};

export default New_opportunity;
